import { useEffect, useState } from 'react'

import { useAuth, useMessage, useRouter } from '@/core'
import { useAnalytics } from '@/core/analytics'
import { makeViewModel } from '@/core/architecture'

import { Action, State } from './template'

export const useViewModel = makeViewModel<State, Action>(() => {
  const { confirmPasswordReset } = useAuth()

  const { email, verifiedCode } = useVerifyPasswordResetCode()
  const { analytics } = useAnalytics()

  return {
    state: {
      email,
    },
    actions: {
      onSubmitPasswordReset: async ({ password }) => {
        analytics?.track('click_resetPassword')
        confirmPasswordReset(verifiedCode, password)
      },
    },
  }
})

type ResetPasswordQueryParams = {
  oobCode: string
}
/**
 * @description
 * パスワードリセットURLのクエリパラメータを基に、コードの正当性を確認して正しければ再設定email,codeを返す。
 *
 * @returns email パスワード再設定するメールアドレス
 * @returns verifiedCode 認証コード
 * @returns loading 認証コード確認中のローディング
 */
const useVerifyPasswordResetCode = () => {
  const [loading, setLoading] = useState(false)
  const [email, setEmail] = useState('')
  const [verifiedCode, setVerifiedCode] = useState('')

  const { showError } = useMessage()
  const { router } = useRouter<ResetPasswordQueryParams>()
  const { oobCode: code } = router.query

  const { verifyPasswordResetCode } = useAuth()

  useEffect(() => {
    if (code) {
      setLoading(true)
      verifyPasswordResetCode(code)
        .then(email => {
          setEmail(email)
          setVerifiedCode(code)
        })
        .catch(e => showError(e))
        .finally(() => setLoading(false))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [code])

  return { email, verifiedCode, loading }
}
